// removed by extract-text-webpack-plugin
module.exports = {"Wrap":"_1AYAFC0Kxpid60RQodxqLf","HeadingText":"NO0sEH-pCNWT6x4_hhE0E","Description":"_2jBCaEN42aMTmJJkCbQ3y0"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/CompanySettings/Installation/InfoBubble/style.css
// module id = 1996
// module chunks = 0